const showMore = document.querySelector('.reviews__show');
const productsLength = document.querySelectorAll('.reviews__item').length;
let items = 6;

showMore.addEventListener('click', () => {
	items += 3;
	const array = Array.from(document.querySelector('.reviews__list').children);
	const visItems = array.slice(0, items);

	visItems.forEach(el => el.classList.add('is-visible'));

	if (visItems.length === productsLength) {
		showMore.style.display = 'none';
	}
});
